<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/info' }">账户设置</el-breadcrumb-item>
            <el-breadcrumb-item>服务需求</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <el-form :inline="true" :model="formFilter" class="demo-form-inline">
                <el-form-item label="服务内容">
                    <el-input v-model="formFilter.name" placeholder="请填写服务内容"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onFilter">查询</el-button>
<!--                    <el-button type="default" @click="goPage('/index/info/addservice')">创建服务内容</el-button>-->
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <div class="table" style="padding-top: 15px;">
                <el-table
                    :data="data"
                    :border="true"
                    :stripe="true"
                    tooltip-effect="dark"
                >
                    <el-table-column
                        prop="no"
                        width="160"
                        label="需求编号"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="create_time"
                        width="160"
                        align="center"
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        prop="category"
                        align="center"
                        width="200"
                        label="类别">
                    </el-table-column>
                    <el-table-column
                        prop="unit"
                        align="center"
                        width="100"
                        :show-overflow-tooltip="true"
                        label="单位">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="服务内容">
                    </el-table-column>
                    <el-table-column
                        prop="demand"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="服务要求">
                    </el-table-column>
                </el-table>
                <div class="pagination" v-if="total_page > 1">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="10"
                        :current-page="currentPage"
                        @current-change="onPageChange"
                        :page-count="total_page">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog title="服务需求详情" class="dialog__detail" :visible.sync="dialogVisible">
            <el-form label-position="right" label-width="120px">
                <el-form-item label="需求编号：">
                    <div>{{current.id}}</div>
                </el-form-item>
                <el-form-item label="类别：">
                    <div>{{current.category}}</div>
                </el-form-item>
                <el-form-item label="服务内容：">
                    <div>{{current.name}}</div>
                </el-form-item>
                <el-form-item label="单位：">
                    <div>{{current.unit}}</div>
                </el-form-item>
                <el-form-item label="服务要求：">
                    <div>{{current.demand}}</div>
                </el-form-item>
                <el-form-item label="申请时间：">
                    <div>{{current.create_time}}</div>
                </el-form-item>
                <el-form-item label="审核状态：">
                    {{statusList[current.status]}}
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>

</template>

<script>
import Vue from 'vue'
import { Popover } from 'element-ui'
Vue.use(Popover)
export default {
    name: 'Main',
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            dialogVisible: false,
            data: [],
            statusList: ['待运营审批', '待风控审批', '审批不通过', '已关闭', '已完成', '已失效'],
            formFilter: {
                name: '',
                status: ''
            },
            current: {},
            total_page: 1,
            currentPage: 1
        }
    },
    mounted () {
        this.getList()
    },
    methods: {
        onPageChange (e) {
            this.getList(e)
        },
        getList (page = 1) {
            this.$http.get('/api/user/service/lists', {
                params: {
                    name: this.formFilter.name,
                    status: 4,
                    size: 10,
                    page: page
                }
            })
                .then((res) => {
                    if (res.code === 0) {
                        this.data = res.data.listData
                        this.total_page = res.data.total_page
                    } else {
                        this.$Message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        showDetail (id) {
            let cur = this.data.filter((item) => {
                if (item.id * 1 === id * 1) {
                    return item
                }
            })
            this.current = cur[0]
            this.dialogVisible = true
        },
        remove (id) {
            this.$confirm('此操作将永久删除该服务需求, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get('/api/user/service/delete', {
                    params: {
                        id
                    }
                })
                    .then(res => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '删除成功'
                            })
                            this.getList()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            })
        },
        onFilter () {
            this.getList(1)
        }
    }
}
</script>
<style scoped lang="scss">
    @import "../../assets/style/sub";

    .data-overview {
        height: 78px;
    }
</style>
